import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom, InjectionToken } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

import { environment } from '../config/environments/environment';
import { routes } from './app.routes';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { UserService, AuditLogService, API_BASE_URL } from '../service/proxy';

import { EVENT_SOURCE_URL } from './shared/services/tokens.service';

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(
            OktaAuthModule.forRoot({
                oktaAuth: new OktaAuth({
                    issuer: environment.okta.issuer,
                    clientId: environment.okta.clientId,
                    redirectUri: environment.okta.redirectUri,
                    postLogoutRedirectUri: environment.okta.postLogoutRedirectUri,
                    scopes: environment.okta.scopes,
                    pkce: environment.okta.pkce
                })
            })
        ),

        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),

        provideHttpClient(
            withInterceptors([
                authInterceptor
            ])
        ),

        {
            provide: API_BASE_URL,
            useValue: environment.apiBaseUrl
        },
        {
            provide: EVENT_SOURCE_URL,
            useValue: environment.apiBaseUrl
        },

        UserService,
        AuditLogService,
    ]
};